import{ConfigurationFlag as r}from"@dfg/brahma-types";var n=function(n){return function(t){return t&&""!==t?t!==r.YES&&t!==r.NO?n:"":n}},t=function(n){return function(t){return t&&""!==t&&t===r.YES?"":n}};export{n as validateBoolean,t as validateRequiredBoolean};
//# sourceMappingURL=index.js.map
